import ReportAPI from './api'

const api = new ReportAPI()

export default {
  api,
}
